import Headroom from 'react-headroom'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Nav from './nav-new'

const isMobile = typeof window !== 'undefined' ? window.innerWidth < 1024 : false

const HeaderWrapper = ({
  onUnpin,
  onUnfix,
  hideOnScroll,
  wrapperStyle,
  disable,
  children
}) => (
  hideOnScroll
    ? <Headroom
      onUnpin={onUnpin}
      onUnfix={onUnfix}
      disableInlineStyles
      downTolerance={25}
      style={{ transition: 'all 0.3s' }}
      wrapperStyle={wrapperStyle}
      disable={disable}
    >
      {children}
    </Headroom>
    : children
)

class Header extends Component {
  constructor (props) {
    super(props)
    this.handleOnUnpin = this.handleOnUnpin.bind(this)
    this.handleOnUnfix = this.handleOnUnfix.bind(this)
  }

  handleOnUnpin () {
    document.getElementsByClassName('header-new')[0].classList.add('header--fixed-top')
  }

  handleOnUnfix () {
    document.getElementsByClassName('header-new')[0].classList.remove('header--fixed-top')
  }

  render () {
    const fixedOption = this.props.fixed ? 'header--fixed' : ''
    const hideOnScroll = this.props.fixed && !isMobile ? this.props.hideOnScroll : true

    return (
      <div className='header-wrapper'>
        <HeaderWrapper
          onUnpin={this.handleOnUnpin}
          onUnfix={this.handleOnUnfix}
          hideOnScroll={hideOnScroll}
          wrapperStyle={{ position: 'relative', zIndex: 6 }}
          disable={!isMobile}
        >
          <header className={`candle-header-new ${fixedOption}`}>
            <img src='/img/Candle_Logo_Alpha_01.png' />
          </header>
        </HeaderWrapper>
        <HeaderWrapper hideOnScroll={this.props.hideOnScroll}>
          <header className={`header-new ${fixedOption}`}>
            <Nav theme={this.props.theme} />
          </header>
        </HeaderWrapper>
      </div>
    )
  }
}

Header.defaultProps = {
  hideOnScroll: true,
  fixed: false
}

Header.propTypes = {
  fixed: PropTypes.bool,
  theme: PropTypes.string,
  hideOnScroll: PropTypes.bool
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header-new.js